import { FC } from "react";
import AvScanInfectedSvg from "../../public/icons/AvScanInfected.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const AvScanInfectedIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><AvScanInfectedSvg/></span>;
